import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

const { semanticColors } = capitalDesignTokens;

export const styles = createTypedSxStyles({
  menuPaper: {
    maxHeight: 264,
  },
  itemDescription: {
    color: semanticColors.foreground.secondary,
    fontSize: 12,
  },
});
